import React, { Component } from "react";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuFR from "../../components/fr/MenuFR";
import FooterFR from "../../components/fr/FooterFR";

class Index extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Layout>
                <Meta
                    title={"Anna Mamchenkova – comptabilité et contrôle de gestion"}
                    description={"Comptable, spécialiste des questions de gestion et de rentabilité, Anna coordonne les dossiers liés aux entreprises en difficulté."}
                    url={"https://www.coeladvocaten.be/fr/anna-mamchenkova"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/anna-mamchenkova", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/anna-mamchenkova", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/anna-mamchenkova", language:"en" }
                    ]}
                />

                <MenuFR
                    switchUrlNL="/nl/anna-mamchenkova"
                    switchUrlEN="/en/anna-mamchenkova"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-team"></div>
                        <div className="slider">
                            <h1>Notre équipe</h1>
                            <h2>Anna Mamchenkova</h2>
                            <p></p>
                            <a href="/fr/contact" alt="contact" className="button">info@coeladvocaten.be</a>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row">
                                <div className="col-lg-4">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <div className="image">
                                                <img className="img-fluid grayscale team-image-opacity" src="/static/images/ons-team-anna.jpg" width="100%" height="auto" /> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-8">
                                    <div className="slider">
                                        <div className="margin-top">
                                            <p></p>
                                            <p>Titulaire d’un diplôme d’ingénieure en métallurgie, Anna Mamchenkova garde de cette première formation le sens du détail et la conscience de l’importance d’étudier l’ensemble des paramètres d’une situation avant de prendre une décision.</p>
                                            <p>Dès son arrivée en Belgique, Anna se lance dans des études de comptabilité et de gestion. Rapidement, sa nature analytique prend le dessus et elle réalise que son intérêt réside dans l’utilisation de la comptabilité comme: </p>
                                            <p>-	instrument essentiel dans la valorisation</p>
                                            <p>-	outil d’analyse et de diagnostic de la santé financière et opérationnelle</p>
                                            <p>-	aide à la prise de décisions en matière de gestion.</p>
                                            <p>Après plusieurs expériences en tant que comptable et spécialiste du contrôle de gestion, elle rejoint le cabinet Coel & Advocaten en tant que responsable de la comptabilité.</p>
                                            <p>Très vite, elle y prendra de nouvelles responsabilités et mettra ses compétences en comptabilité et en gestion au service des clients de Frank Coel. Elle intervient notamment pour accompagner la restructuration ou le redressement d’entreprises, pour aider à la valorisation des entreprises lors de cessions, de fusions ou d’acquisitions, et pour accompagner les opérations liées à la cessation d’activités.</p>
                                            <p>Aujourd’hui, Anna Mamchenkova, outre ses responsabilités en matière de comptabilité et d’organisation du cabinet, coordonne l’activité de conseil aux entreprises en difficulté.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row"><br /></div>
                        </div>
                    </div>
                </div>

                <FooterFR />
            </Layout>
        );
    }
}

export default Index;
